import axios from 'axios';
import concat from 'lodash/concat';
import uniqBy from 'lodash/uniqBy';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
import { BASE_URL } from '@/constants/constants';

const rootUrl = BASE_URL;

export default {
    state: {
        fixtures_list: [],
        fixture_types: []
    },
    
    actions: {
        clearFixturesData({ commit }) {
            commit('setFixtures', []);
            commit('setFixtureTypes', []);
        },

        fetchFixtures({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.get(`${rootUrl}/account/application/2/fixture`, { headers: headers }).then((response) => {
                    commit('setFixtures', response.data);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        fetchFixtureTypes({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.get(`${rootUrl}/account/application/2/building_fixture_type`, { headers: headers }).then((response) => {
                    commit('setFixtureTypes', response.data);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getFixturesData({ commit, dispatch }) {
            // gets fixture_types from local storage
            Storage.get({ key: 'fixtures_list' }).then((response) => {
                let fixtures_list = JSON.parse(response.value);
                
                if (fixtures_list) {
                    commit('setFixtures', fixtures_list);
                }

                dispatch('fetchFixtures');
            });
        },

        getFixtureTypesData({ commit, dispatch }) {
            // gets fixture_types from local storage
            Storage.get({ key: 'fixture_types' }).then((response) => {
                let fixture_types = JSON.parse(response.value);
                
                if (fixture_types) {
                    commit('setFixtureTypes', fixture_types);
                }

                dispatch('fetchFixtureTypes');
            });
        },

        updateFixtureDB({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.post(`${rootUrl}/account/application/2/fixture/${data.id}`, data.content, { headers: headers }).then((response) => {
                    commit('updateFixtureStore', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        createFixtureDB({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.put(`${rootUrl}/account/application/2/fixture/`, data, { headers: headers }).then((response) => {
                    commit('updateFixtureStore', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        deleteFixtureDB({ commit, rootState }, fixtureID) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.delete(`${rootUrl}/account/application/2/fixture/${fixtureID}`, { headers: headers }).then((response) => {
                    commit('deleteFixtureStore', fixtureID);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    },

    getters: {
        getFixturesList: (state, getters, rootState) => {
            // get a list of fixtures for active subscription

            let fixtures = state.fixtures_list.filter((fixture) => {
                fixture.type_name = state.fixture_types.filter((type) => {
                    return type.id === fixture.type;
                })[0].name;

                if (fixture.subscriptions.includes(rootState.subscriptions.active_subscription.id)) {
                    return fixture;
                }
            });

            fixtures.sort((a, b) => {
                return a.type_name.toLowerCase() > b.type_name.toLowerCase() ? 1 : -1;
            });

            return fixtures;
        },

        getFixtureTypes: (state, getters, rootState) => {
            // get a list of fixture types for active subscription

            let types = state.fixture_types.filter((type) => {
                return type.subscriptions.includes(rootState.subscriptions.active_subscription.id);
            });

            types.sort((a, b) => {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
            });

            return types;
        },

        getFixture: (state) => (id) => {
            // get a specific fixture

            let fixture = state.fixtures_list.find((fixture) => {
                fixture.type_name = state.fixture_types.filter((type) => {
                    return type.id === fixture.type;
                })[0].name;

                return fixture.id === id;
            });

            return fixture;
        },

        getFixtureByType: (state, getters, rootState) => (id) => {
            // get a specific fixture by type id

            let fixture = state.fixtures_list.find((fixture) => {
                fixture.type_name = state.fixture_types.filter((type) => {
                    return type.id === fixture.type;
                })[0].name;

                const typeMatch = fixture.type === id,
                    subscriptionMatch = fixture.subscriptions.includes(rootState.subscriptions.active_subscription.id);

                return typeMatch && subscriptionMatch;
            });

            return fixture;
        }
    },

    mutations: {
        setFixtures(state, data) {
            state.fixtures_list = data;
            
            Storage.set({
                key: 'fixtures_list',
                value: JSON.stringify(data)
            });
        },

        updateFixtureStore(state, data) {
            let list = concat([data], state.fixtures_list);
            list = uniqBy(list, 'id');

            state.fixtures_list = list;

            Storage.set({
                key: 'fixtures_list',
                value: JSON.stringify(list)
            });
        },

        deleteFixtureStore(state, fixtureID) {
            let list = state.fixtures_list.filter((fixture) => {
                return fixture.id !== fixtureID;
            });

            state.fixtures_list = list;

            Storage.set({
                key: 'fixtures_list',
                value: JSON.stringify(list)
            });
        },

        setFixtureTypes(state, data) {
            state.fixture_types = data;
            
            Storage.set({
                key: 'fixture_types',
                value: JSON.stringify(data)
            });
        }
    },
};